import React, { useCallback, useContext, useEffect, useState } from 'react';
import CrossIcon from '../../../assets/images/close.png';
import { Button } from 'app/components';
import { useTranslation } from 'react-i18next';
import { Selection } from './styles';
import { RowButton } from './styles';
import { LineBordered, Svg } from 'app/components';
import { Total } from 'app/modules/order/SelectionTotal/styles';
import { useConfig } from 'app/hooks';
import { generatePath, useHistory } from 'react-router-dom';
import ConfigContext from 'app/context/config';
import { useSelector } from 'react-redux';

const SnacksAsideMobileComponent = ({ setConcessionOnServer, setConcessionComboOnServer, requestConcessionOnServer, requestConcessionComboOnServer, removeConcession, selectedItems, handleRemoveItem, movieCinemaId }) => {
  const [t] = useTranslation();
  const {
    api: { endpoint }
  } = useConfig();
  const orderData = useSelector(state => state?.order?.userSessionId);
  const { routes } = useContext(ConfigContext);
  const [isExpanded, toggleExpand] = useState(false);
  const [summeDetails, setSummeDetails] = useState(false);
  const [selectedNormalSessionItems, setSelectedNormalSessionItems] = useState([]);
  const [selectedComboItems, setSelectedComboItems] = useState([]);
  const [selectedItemsData, setSelectedItemsData] = useState({});
  const history = useHistory();

  useEffect(() => {
    const data = { ...selectedItems?.normalSession, ...selectedItems?.comboSession };
    setSelectedItemsData(data);
  }, [selectedItems]);

  // for ConcessionData and ComboData
  useEffect(() => {
    setConcessionOnServer(null);
    setConcessionComboOnServer(null);
  }, []);

  const handleSummeDetail = () => {
    setSummeDetails(!summeDetails);
    toggleExpand(!isExpanded);
  }

  function convertCentsToDollars(priceInCents) {
    if (typeof priceInCents !== 'number' || isNaN(priceInCents)) {
      return 'Invalid input';
    }

    const dollars = Math.floor(priceInCents / 100);
    const cents = priceInCents % 100;

    const formattedCents = cents < 10 ? `0${cents}` : `${cents}`;

    return `${dollars}.${formattedCents}`;
  }

  // Calculate total amount based on selected items
  const calculateTotal = () => {
    let total = 0;
    Object.values(selectedItemsData).forEach(item => {
      if (item?.priceInCents > 0 && item?.quantity > 0) {
        total += item.quantity * item.priceInCents;
      }
    });
    return convertCentsToDollars(total);
  };
  useEffect(() => {
    const normalSessionData = Object.values(selectedItems['normalSession'])?.filter(item => item?.quantity > 0)?.map((item) => ({
      itemId: item.id,
      Description: item.description,
      priceInCents: item.priceInCents,
      numberOfConcessionItem: item.quantity,
      "CollectedStatus": 0
    }));
    if (normalSessionData.length > 0) {
      setSelectedNormalSessionItems(normalSessionData);
    } else {
      setSelectedNormalSessionItems([]);
    }
  }, [selectedItems]);

  useEffect(() => {
    const comboSessionItems = Object.values(selectedItems?.comboSession || {}).filter(item => item.quantity > 0).map(item => ({
      itemId: item.id,
      cinemaId: item.cinemaId,
      quantity: item.quantity,
      packageChildItems: item.packageChildItems?.map(child => ({
        ItemId: child.ItemId,
        quantity: child.quantity,
        ...(child.ParentSaleItem ? { ParentSaleItem: child.ParentSaleItem } : {})
      })) || []
    }));
    setSelectedComboItems(comboSessionItems);
  }, [selectedItems]);

  const next = useCallback(() => {
    if (selectedNormalSessionItems?.length > 0) {
      requestConcessionOnServer(orderData, selectedNormalSessionItems);
    } else if (selectedNormalSessionItems?.length === 0 && selectedComboItems?.length === 0) {
      removeConcession(orderData);
    }
    if (selectedComboItems?.length > 0) {
      requestConcessionComboOnServer(orderData, selectedComboItems);
    }
    history.push(generatePath(routes.stepCheckout.pattern, { movieCinemaId }));
  }, [selectedNormalSessionItems, selectedComboItems]);

  return (
    <>
      <Selection className={isExpanded ? '_expanded' : ''}>
        <div
          className="b-selection-total-mob__mask"
          aria-hidden
        />
        <div
          className="b-selection-total-mob__info-wrapper"
          aria-hidden
          style={{
            flexDirection: 'column'
          }}
        >
          {!summeDetails &&
            <div>
              <div className="b-selection-total-mob__info">
                <div className="b-selection-total-mob__info-inner-summe">
                  <p className="b-selection-total-mob__info-title">Summe</p>
                  <p className="b-selection-total-mob__info-value">£ {calculateTotal()}</p>
                </div>
              </div>

              <div className="b-selection-total-mob__info"
                style={{
                  display: "flex",
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '10px'
                }}
              >
                <div className="b-selection-total-mob__info-inner">
                  <p className="b-selection-total-mob__info-title">See details</p>
                </div>
                <span className="_with-chevron"
                  onClick={handleSummeDetail}
                />
              </div>
            </div>}

          <div>
            {
              Object.keys(selectedItemsData).length ? (
                <div className="b-selection-total-mob__description">
                  <div>
                    <div className='selection-mob-main-section'>
                      <h3 className='heading_detail'>Summe Details</h3>
                      <span onClick={handleSummeDetail}>
                        <img
                          className='cross-icon-img'
                          src={CrossIcon} alt='CrossIcon' />
                      </span>
                    </div>
                    <hr className='horizontal-lines-aside-mobile-view' />
                  </div>
                  {
                    Object.values(selectedItemsData)?.filter(item => item?.priceInCents > 0).map((item, index) => (
                      <div className='' style={{
                        padding: '0px 16px',
                      }}>
                        <div
                          style={{
                            borderTop: `${index !== 0 && "1px solid rgba(255, 255, 255, 0.08)"
                              }`,
                            padding: '16px 0px',
                          }}
                        >
                          <div className='main-section-mob-view'>
                            <div className='sub-main-mob-section'>
                              <div className='img-section'>
                                <img className='item-imgs' src={`${endpoint}${item?.imagePath}`} alt={item?.imagePath} />
                                <span className='item-imgs-mob-view' onClick={() => handleRemoveItem(item?.id, item?.isCombo ? 'comboSession' : 'normalSession')}>
                                  <img className='crossIcon-imgs' src={CrossIcon} alt='CrossIcon' />
                                </span>
                              </div>
                              <div><span className='item-description-mob-view'>{item?.description}</span></div>
                            </div>
                            <div className='total-main-section-mob-view'>
                              <span className='sub-main-section'>
                                {item?.quantity} x £{convertCentsToDollars(item?.priceInCents)}
                              </span>
                              <span>
                                £ {convertCentsToDollars(item?.quantity * item?.priceInCents)}
                              </span>
                            </div>
                          </div>
                        </div >
                      </div >
                    ))
                  }
                  <LineBordered style={{
                    marginTop: '20px',
                  }}>
                    <Total>
                      <Svg id="cart" />
                      <span className='total-font'>{t('purchase.total')}:</span>
                    </Total>

                    <strong className='total-amount-font'>
                      £ {calculateTotal()}
                    </strong>
                  </LineBordered>
                </div>
              ) :
                summeDetails && <div className='no-items-selected'
                  onClick={handleSummeDetail}>
                  No Item is Selected
                </div>
            }
          </div>
          <RowButton>
            <Button isPrimary
              // disabled={!Object.keys(selectedItemsData).length}
              onClick={next}
            >
              {t('purchase.next')}
            </Button>
          </RowButton>
        </div>

      </Selection>
    </>
  )
}

export default SnacksAsideMobileComponent;